import styled from 'styled-components'

import { StyledSubscriptions } from './Subscriptions.styles'

export const StyledPianoSubscriptions = {
  AdditionalSubscriptions: styled(
    StyledSubscriptions.DetailedSubscriptionsWrapper,
  )`
    margin-top: 16px;

    &:empty {
      display: none;
    }
  `,
}
